export const SETTING_TOPICS = {
  EMAILS: 'emails',
  APPOINTMENTS: 'appointments',
  AI: 'ai',
  LAW_OFFICE_SOFTWARE: 'law-office-software',
  QUESTIONNAIRES: 'questionnaires',
  ONBOARDING_PACKAGES: 'onboarding-packages',
  AI_PHONE_ANSWERING: 'ai-phone-answering',
  DOCUMENT_TEMPLATES: 'document-templates',
  PDF_FORM_TEMPLATES: 'pdf-form-templates',
  CLIENT_ONBOARDING: 'client-onboarding'
}

export const SETTING_PAGES = {
  EMAILS: {
    JUPUS_EMAIL: 'jupus-email',
    TEMPLATES: 'templates',
    DESIGN: 'design',
    SIGNATURES: 'signatures',
    NOTIFICATIONS: 'notifications',
    PLACEHOLDERS: 'placeholders',
    DELIVERY_STATUS: 'delivery-status'
  },
  APPOINTMENTS: {
    SETUP: 'setup',
    CALENDAR_LIST: 'calendars',
    CALENDAR_DETAIL: 'calendars',
    SERVICE_LIST: 'services',
    SERVICE_DETAIL: 'services',
    BASE_SETTINGS: 'base-settings',
    LINKS: 'links',
    EMBED: 'embed'
  },
  AI: {
    BASE_SETTINGS: 'base-settings',
    ENTITY_EXTRACTION: 'entity-extraction',
    DOCUMENT_GENERATION_TEMPLATES: 'document-generation-templates',
    PROMPT_TEMPLATES: 'prompt-templates',
    AUTO_COMMIT: 'auto-commit',
    CASE_LIFECYCLE_WORKFLOWS: 'case-lifecycle-workflows',
    CASE_LIFECYCLE_WORKFLOWS_BASIC_SETTINGS: 'case-lifecycle-workflows/basic-settings',
    AI_AUTONOMY: 'ai-autonomy',
    AI_NOTIFICATIONS: 'ai-notifications'
  },
  AI_PHONE_ANSWERING: {
    PHONE_NUMBERS: 'phone-numbers',
    PHONE_FORWARDING_RULES: 'phone-forwarding-rules'
  },
  LAW_OFFICE_SOFTWARE: {
    RA_MICRO: 'ra-micro',
    ACTAPORT: 'actaport',
    ADVOLUX: 'advolux',
    ADVOWARE: 'advoware',
    LAWFIRM: 'lawfirm',
    JURNODES: 'jurnodes',
    DATEV: 'datev',
    KLEOS: 'kleos',
    KLEOS_OAUTH: 'kleos-oauth'
  },
  QUESTIONNAIRES: {
    QUESTIONNAIRE_LIST: 'questionnaires',
    QUESTIONNAIRE_DETAIL: 'questionnaires'
  },
  DOCUMENT_TEMPLATES: 'document-templates',
  PDF_FORM_TEMPLATES: {
    PDF_FORM_TEMPLATES: 'pdf-form-templates'
  }
}
